import { NySession } from '@nybble/nyreact';
import React from 'react';
import ProjectIndex from '.';

const SubprojectList = () => {
    return <ProjectIndex tableIndex="tableIndex.subprojects" parentId={NySession.getProjectId()} />;
};

export default SubprojectList;
